import {L} from "../../lt-ng/landcare-toolkit";
import {Panes} from "../../controllers/panes";
import {AppPane, ContainingPane, IAppConfig, BaseAppConfig} from "./app_config";
import {TourEvents} from "../ITourService";
import {Extent} from "ol/extent";
import filterNodes = L.tree.filterNodes;
import Item = L.tree.Item;
import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {IBaseGeoAppScope} from "../../controllers/IBaseGeoAppScope";
import {IReportFromUrlService} from "../smap/report-from-url-service";
import {ISharedFeatureControlState, ReportKind} from "../ISharedFeatureState";

export class SMapAppConfig extends BaseAppConfig implements IAppConfig {
    printModuleApplication(): string {
        let licenseKey = L.util.Layer.getLicenseKey();
        return `smap_${licenseKey}`;
    }

    public static $inject = ['$location', 'reportFromUrlService'];

    constructor(protected $location: ng.ILocationService, protected reportFromUrlService: IReportFromUrlService) {
            super();
    }

    pointQueryPane: string = Panes.Ids.FEATURES;
    deselectPinOnPaneClose: boolean = false; // TODO: maintains current behavior, check if this is correct GPOENVB-583

    includeItemsByDefault(): boolean {
        return true;
    }

    expandGroupsByDefault(): boolean {
        return true;
    }

    multiplePinsInRHP(): boolean {
        return true;
    }

    tourURL(): string {
        return "/app-page/javascript/tours/smap-tour.js";
    }

    layerExtent: Extent = [846720, 4426240, 2365440, 6496000];

    getContainingPane(pane: AppPane): ContainingPane {
        switch (pane) {
            case "Search": return 'paneLeftCollapsed';
            case "Layers": return 'paneLeftCollapsed';
            case "Pins": return 'paneLeftCollapsed';
            case "Metadata": return 'paneBottomCollapse';
            case "Overview": return 'paneBottomCollapse';
            case "Legend": return 'paneBottomCollapse';
            case "Features": return 'paneRightCollapse';
            case "Properties": return 'paneRightCollapse';
            case "SoilSummary": return 'paneRightCollapse';
            default: return null;
        }
    }


    isSingleClickAddPin(): boolean {
        return true;
    }

    isSingleClickActive(sharedState: ISharedFeatureControlState): boolean {
        if (sharedState.featureMode && sharedState.featureMode !== "pin") return false;

        const activeReport = sharedState.activeReport;
        return !activeReport || [ReportKind.pin, ReportKind.multiplePin].includes(activeReport.kind);
    }

    getApplication() {
        return 'smap_v2';
    }

    initGeoApp($scope: IBaseGeoAppScope, mapService: IMapService): void {
        if (!window.localStorage.getItem('helpShown')) {
            window.localStorage.setItem('helpShown', '1');
            if (!this.$location.search()['tour']
             && !this.$location.search()['soilmapuc']) {
                $scope.showHelpModal();
            }
        }

        if (this.$location.search()['tour']) {
            $scope.$emit(TourEvents.start);
        }

        this.reportFromUrlService.init(mapService);
    }

    getLayersForPointQuery(treeDate: Item | Item[]): Item[] {
        const nodes = filterNodes(treeDate, node => {
            return node && node.layerService && node.layerService.layerName.includes('smap_');
        });

        return nodes.length ? [nodes[0]] : [];
    }
}
